import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { CalendarioService } from "src/app/services/calendario.service";
import { obterCalendarioPublicacao, obterCalendarioPublicacaoFailure, obterCalendarioPublicacaoSuccess } from "../actions/obter-calendarios-publicacoes.action";

@Injectable()
export class ObterCalendariosPublicacoesEffects {

  public obterCalendariosPublicacoes$: unknown;

  constructor(private readonly actions$: Actions,
    private readonly calendarioService: CalendarioService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterCalendariosPublicacoes$ = createEffect(() => this.actions$.pipe(
      ofType(obterCalendarioPublicacao),
      switchMap(({ inputDto }) =>
        this.calendarioService
          .ObterCalendariosPublicacoes(inputDto)
          .pipe(
            map(
              response => {
              if (response.erros != undefined && response.erros.length > 0) {
                return obterCalendarioPublicacaoFailure({ response })
              }
              return obterCalendarioPublicacaoSuccess({ response })
            }),
            catchError(() => {
              return of()}
            )
          )
      )
    )
    );
  }
}
